<template>
  <div class="cc-footer">
    <div class="position-relative row m-0 p-10 linha-abaixo-cinza">
      <div class="col-12 p-0">
        <div class="info-usuario">
          <div class="info-usuario-title text-uppercase font-weight-bold m-0">
            Dados do Profissional
          </div>
          <div class="info-usuario-data c-grey-light">
            {{ professionalData.nome }}
          </div>
          <div class="info-usuario-data c-grey-light">
            Telefone: {{ professionalData.telefone }}
          </div>
          <div
            class="info-usuario-data c-grey-light"
            v-if="professionalData.cnpj"
          >
            CNPJ: {{ professionalData.cnpj }}
          </div>
          <div
            class="info-usuario-data c-grey-light"
            v-if="professionalData.cpf"
          >
            CPF: {{ professionalData.cpf }}
          </div>
          <div class="info-usuario-data c-grey-light">
            {{ professionalData.endereco }},
            {{ professionalData.cidade.nome }} -
            {{ professionalData.estado.uf }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    professionalData: {
      required: true,
    },
  },
};
</script>
